import React from 'react';
import Halloween from '../../src/LayoutCovers/Halloween';
import Christmas from '../../src/LayoutCovers/Christmas';

const OverlaySwitcher = () => {
    const month = new Date().getMonth() + 1; // 1 = Jan, 10 = Oct, 12 = Dec

    if (month === 13) {
        return <Halloween />;
    }
    else if (month === 13) {
        return <Christmas />;
    }
    else {
    }
};

export default OverlaySwitcher;
